import SignalSource from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalSource";

export function leadScoringSignalSourceExtractor(): SignalSource {
    return SignalSource.Platform;
}
